module Meevo.Plugins.ClientManualMerge {
    class ClientManualMergeController {

        closeContext: Function;
        context: ClientManualMergeContext;
   
        static $inject = [
          "meevo.AppSettings",
          "meevo.components.common.DataService",
          "meevo.components.modal.ModalService",
          "meevo.components.tracking.TrackingService",
          "meevo.components.common.IdentityService",
          "$rootScope",
          "$state"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
          protected dataService: Meevo.Components.BaseClasses.IDataService,
          protected modalService: Meevo.Components.Modal.IModalService,
          protected trackingService: Meevo.Components.Tracking.ITrackingService,
          protected identityService: Meevo.Components.Common.IIdentityService,
          protected $rootScope: angular.IRootScopeService,
          protected $state: any) {
            
            let vm = this;
            vm.context = new ClientManualMergeContext(appSettings, dataService, modalService, trackingService, identityService, $rootScope);
            vm.closeContext = (): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }
        }
    }

    angular.module("meevo.plugins.clientManualMerge")
        .controller("meevo.plugins.clientManualMerge.ClientManualMergeController", ClientManualMergeController);
}